import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";
import { AddKontakDarurat } from "../../../../models/KontakDarurat";
import { allKontakDaruratKey } from "./useFetchKontakDarurat";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";

export async function addKontakDarurat(data: AddKontakDarurat) {
    const res = await ApiClient.post(`/AddEmergencyContact`, data);
    return res.data;
}

export const useAddKontakDarurat = mutationWrapper(addKontakDarurat, {
    onSuccess: () => {
        getQueryClient().invalidateQueries(allKontakDaruratKey);
        getQueryClient().invalidateQueries(checkProfileKey)
    },
});
